<style lang="less" scoped>
    .stock-picker{
        display: inline-block;
        width: 100%;
        vertical-align: middle;
        .ivu-poptip{
            width: 100%;
            /deep/ .ivu-poptip-rel{
                width: 100%;
            }
        }
        .default-slot{
            /deep/ .ivu-btn {
                padding: 6px 7px;
                text-align: left;
            }
            /deep/ .ivu-btn-small {
                padding: 2px 7px;
            }
        }
    }
    .stock{
        margin-bottom: 5px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        border: 1px solid #dddee1;
        padding: 5px 8px;
        cursor: pointer;
        &:hover{
            background: #f5f5f5;
        }
    }
    .sub-stocks{
        padding-left: 8px;
        white-space: normal;
    }
</style>
<template>
    <div class="stock-picker">
        <Poptip :transfer="true" width="450" :placement="placement" @on-popper-show="popShow">
            <div class="default-slot">
                <slot>请选择</slot>
            </div>
            <div slot="content">
                <i-input size="small" v-model="params.search" @on-enter="search" placeholder="搜索存货...">
                    <Button slot="append" icon="ios-search" @click="search" :loading="loading"></Button>
                </i-input>
                <div class="hr"></div>
                <div class="stock" v-for="stock in stocks" @click="selectStock(stock)" :key="stock.id">
                    <span>{{stockText(stock)}}</span>  <span style="color:#33CCCC">{{stock.name}}</span>
                </div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
            },
            warehouseCode: {
                type: [String, Number],
                default: ''
            },
            placement: {
                type: String,
                default: 'bottom-start'
            }
        },
        data(){
            return {
                params: {
                    search: '',
                    page: 1,
                    per_page: 5
                },
                stocks: [],
                loading: false
            }
        },
        computed: {
            normalizedWarehouseCode() {
                return this.warehouseCode === undefined || this.warehouseCode === null
                    ? ''
                    : String(this.warehouseCode);
            },
            hasValidWarehouse() {
                return ['36', '37'].includes(this.normalizedWarehouseCode);
            }
        },
        watch: {
            warehouseCode() {
                this.stocks = [];
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            popShow() {
                if (!this.hasValidWarehouse) {
                    this.$Message.warning('请先选择发货仓');
                    document.body.click();
                    return;
                }
                if (!this.stocks.length) {
                    this.search();
                }
            },
            search(){
                if (!this.hasValidWarehouse) {
                    this.$Message.warning('请先选择发货仓');
                    return;
                }
                this.loading = true;
                Util.ajax.get(Util.api.get_mall_item_group_stocks, {
                    params: Object.assign({}, this.params, {
                        ware_house_code: this.normalizedWarehouseCode
                    })
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    this.stocks = [];
                    if(res.code === 1){
                        let data = res.data;
                        this.stocks = data;
                        if(this.stocks.length === 0){
                            this.$Message.warning('未搜索到相关存货');
                        }
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            stockText(stock) {
                return `${stock.stock_serial_num || '无存货编号'}-${stock.ouetrId}`;
            },
            selectStock(stock){
                if(!stock.stock_serial_num){
                    this.$Modal.warning({title: '提示', content: '无存货编号，无法选择'});
                    return;
                }
                let ouetrId = stock.ouetrId
                let price = stock.cost
                let items_id = stock.item_id
                let sub_item_id = stock.sub_item_id
                let sale_duration = stock.sale_duration
                let available_stock_num = stock.available_stock_num
                let group_id = stock.id
                this.$emit('on-change', `${stock.stock_serial_num}`,ouetrId, price, items_id, sub_item_id,sale_duration,available_stock_num,group_id);
                document.body.click();
            }
        }
    }
</script>
